import * as Sentry from "@sentry/react"
import { StripeError } from "@stripe/stripe-js"

// Every confirmPayment error used to be rethrown unless it was a card or
// validation error: the user saw no message, and Sentry an unhandled
// rejection. E.g. a failed 3-D Secure authentication comes back as an
// invalid_request_error with the code payment_intent_authentication_failure.
export function getConfirmPaymentErrorMessage(
  error: StripeError,
  t: (key: string) => string,
): string {
  if (error.type === "card_error" || error.type === "validation_error") {
    return error.message ?? t("components.checkoutForm.somethingWentWrong")
  }

  if (error.code === "payment_intent_authentication_failure") {
    return t("components.checkoutForm.paymentFailed")
  }

  Sentry.captureException(
    new Error(`confirmPayment failed: ${error.type} ${error.code ?? ""}`),
    { extra: { declineCode: error.decline_code, docUrl: error.doc_url } },
  )

  return t("components.checkoutForm.somethingWentWrong")
}

// The message for the PaymentIntent's last error when the page is opened again
// (e.g. back from a 3-D Secure page).
export function getLastPaymentErrorMessage(
  code: string | undefined,
  t: (key: string) => string,
): string {
  return code === "payment_intent_authentication_failure"
    ? t("components.checkoutForm.paymentFailed")
    : t("components.checkoutForm.somethingWentWrong")
}
